// /Frontend/hoppla-admin/src/components/navigation/SidebarNavItem.tsx

import { Link } from 'react-router-dom';

interface SidebarNavItemProps {
  to: string;
  label: string;
  isActive: boolean;
  badgeCount?: number;
}

export function SidebarNavItem({
  to,
  label,
  isActive,
  badgeCount = 0,
}: SidebarNavItemProps): JSX.Element {
  return (
    <Link
      to={to}
      className={`sidebar-nav-item${isActive ? ' is-active' : ''}`}
      aria-current={isActive ? 'page' : undefined}
    >
      <span>{label}</span>
      {badgeCount > 0 ? (
        <span className="sidebar-nav-item__badge" aria-label={`${badgeCount} nouvelle${badgeCount > 1 ? 's' : ''} demande${badgeCount > 1 ? 's' : ''}`}>
          {badgeCount > 9 ? '9+' : badgeCount}
        </span>
      ) : null}
    </Link>
  );
}
